import { FollowOnPortfolioDTO } from '../../component/dto/FollowOnPortfolioDTO';
import { FollowOnModelTotalDTO, FollowOnRoundTotalDTO } from '../../component/dto/FollowOnModelTotalDTO';


export class FollowOnInvestmentCalculationsService {
  /** new Investment is treated as active */
  static countTotal(models: FollowOnPortfolioDTO[], isSold: boolean = false): FollowOnModelTotalDTO {
    return isSold ? this.calculateSoldTotal(models) : this.calculateEditableTotal(models);
  }

  /**
   * Calculates the total allocation amount across all provided models.
   */
  static countFollowOnAllocation(models: FollowOnPortfolioDTO[]): number {
    let allocation = 0;
    models.forEach((model) => {
      model.rounds.forEach((round) => {
        allocation += Number(round.cost ?? 0);
      });
    });
    return allocation;
  }

  /**
   * Calculates the total current compensation value from all provided models.
   */
  private static calcTotalCurrentCompValue(models: FollowOnPortfolioDTO[]): number {
    if (!models) {
      return 0;
    }
    return models.map((model) => model.currentCompValue).reduce((a, b) => a + b, 0);
  }

  /**
   * Calculates the total values for active or new investment models.
   * This method sums up the current cost from all models as well the cost and total rounds for each round in the models.
   *
   * **Note:** It assumes that there are exactly three rounds and initializes the totalActive object accordingly.
   */
  private static calculateEditableTotal(models: FollowOnPortfolioDTO[]): FollowOnModelTotalDTO {
    const totalActive = new FollowOnModelTotalDTO();
    totalActive.currentCompValue = this.calcTotalCurrentCompValue(models);
    totalActive.rounds.push(new FollowOnRoundTotalDTO());
    totalActive.rounds.push(new FollowOnRoundTotalDTO());
    totalActive.rounds.push(new FollowOnRoundTotalDTO());

    models.forEach((model) => {
      totalActive.currentCost += model.currentCost || 0;

      model.rounds.forEach((round, index) => {
        totalActive.rounds[index].totalRound += Number(round.totalRound ?? 0);
        totalActive.rounds[index].cost += Number(round.cost ?? 0);
      });
    });

    return totalActive;
  }

  /**
   * Calculates the total current cost for sold models, iterating through each model and summing up the current cost
   * to calculate the total cost for models marked as sold.
   * It does not calculate round details or compensation values as it assumes models are sold.
   */
  private static calculateSoldTotal(models: FollowOnPortfolioDTO[]): FollowOnModelTotalDTO {
    const soldTotal = new FollowOnModelTotalDTO();
    models.forEach((model) => {
      if (model.currentCost) {
        soldTotal.currentCost += model.currentCost;
      }
    });
    return soldTotal;
  }
}
